import { ACTIONS } from "UTILS/Constants";

const initialState = {
  error: "",
  activeQRScreen: null,
  qrLicenseKey: null,
  isDisabledMenu: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_QR_ERROR:
      return { ...state, error: action.value };
    case ACTIONS.SET_QR_ACTIVE_SCREEN:
      return { ...state, activeQRScreen: action.activeQRScreen };
    case ACTIONS.SET_QR_LICENSE_KEY:
      return { ...state, qrLicenseKey: action.qrLicenseKey };
    case ACTIONS.SET_IS_DISABLED_MENU:
      return { ...state, isDisabledMenu: action.value };
    default:
      return state;
  }
}
